import Vue from 'vue';
import Vuex from 'vuex';
import {AscDesc, ResultType, XHTTPService} from '@/shared/xhttp';
import {
	PaginatorActionWithFilters,
	PaginatorFilterState,
	PaginatorMutation,
	StandardAction
} from '@/shared/utils';
import {Option} from '@/models';
import {OptionService} from '@/xhttp';
import store from '@/stores';
import {OrganisationFilter} from "@/stores/modules/organisateur";

Vue.use(Vuex);

export class OptionFilter {

	public toString(): string {
		return JSON.stringify(this);
	}
}

class OptionState extends PaginatorFilterState<OptionFilter> {
	public option: Option = null;
	public options: ResultType<Option> = null;
	public optionsAll: ResultType<Option> = null;
	public constructor() {
		super(new OrganisationFilter(), 'options', 'option', 'id', AscDesc.DESC, 20)
	}
}

class OptionStore {

	@XHTTPService(() => Option)
	private optionService: OptionService;

	public state: OptionState = new OptionState();

	public mutations = {
		...PaginatorMutation(() => storeOption, 'options', 'option'),
	};

	public actions = {
		...StandardAction<Option, OptionState>(() => Option, 'option'),
		...PaginatorActionWithFilters<Option, OptionState>(() => Option, 'options', 'option'),
	};

}
const instance = new OptionStore();
const storeOption = new Vuex.Store(instance);
store.registerModule('option', storeOption);
export default storeOption;